// CCO: one group compliance officer, and the entities of every other compliance account, in the
// admin view. The server holds the rule (a second active CCO is refused, whatever the door); this
// shows it and lets the admin choose the entities in the same request as the role.
import React from 'react';

// The server's refusals, as sent (admin.py and services/compliance_cco.py), shown in the
// admin's language.
const CCO_DETAILS = {
  'There is already an active group compliance officer (CCO). Choose the entities this compliance account covers.':
    'adminCco.secondCco',
  'One or more entities are not recognised.': 'adminCco.unknownEntity',
  'Too many entities: the list is longer than 100 characters.': 'adminCco.tooLong',
  'Entities apply to the compliance role only.': 'adminCco.notCompliance',
};

export function ccoErrorText(detail, t) {
  const key = typeof detail === 'string' ? CCO_DETAILS[detail] : null;
  return key && typeof t === 'function' ? t(key) : detail;
}

// "Compliance (CCO, group)" for the CCO, "Compliance (<short entities>)" for the others.
export function complianceRoleLabel(user, t) {
  if (!user || user.role !== 'compliance' || typeof t !== 'function') return '';
  const shorts = user.compliance_entities_short || [];
  if (user.is_cco || shorts.length === 0) return t('adminCco.roleCco');
  return t('adminCco.roleScoped', { entities: shorts.join(', ') });
}

// The entities known to canonical_entity, as checkboxes. Leaving every box empty makes the CCO.
export function EntityPicker({ entities, selected, onChange, t, idPrefix }) {
  const chosen = new Set(selected || []);
  const toggle = (name) => {
    const next = new Set(chosen);
    if (next.has(name)) next.delete(name); else next.add(name);
    onChange((entities || []).map(e => e.name).filter(n => next.has(n)));
  };
  return (
    <fieldset data-testid="cco-entity-picker"
              style={{ border: '1px solid #ddd', borderRadius: '6px', padding: '8px 10px', margin: '6px 0' }}>
      <legend style={{ fontSize: '12px', padding: '0 4px' }}>{t('adminCco.entitiesLabel')}</legend>
      {(entities || []).map((e, i) => (
        <label key={e.name} htmlFor={`${idPrefix}-${i}`}
               style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', margin: '2px 0' }}>
          <input id={`${idPrefix}-${i}`} type="checkbox" checked={chosen.has(e.name)}
                 onChange={() => toggle(e.name)} />
          <span>{e.short}</span>
          <span style={{ color: '#888' }}>{e.name}</span>
        </label>
      ))}
    </fieldset>
  );
}
